import { render, staticRenderFns } from "./FlowGauge.vue?vue&type=template&id=3b3dc868"
import script from "./FlowGauge.vue?vue&type=script&lang=js"
export * from "./FlowGauge.vue?vue&type=script&lang=js"
import style0 from "./FlowGauge.vue?vue&type=style&index=0&id=3b3dc868&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports